/**
 * `client_api_key.category` values the shared /v1 pipeline branches on. The
 * full registry (badges, reserved flags) stays in apps/web
 * (lib/api-keys/categories.ts) and re-exports these so the two never drift.
 */

/**
 * Org-scoped keys auto-minted by the @aireserve Slack mention agent
 * (AIR-962), one per org with a Slack Connect channel, created lazily on the
 * channel's first mention. The category is the traffic-attribution hook: the
 * litellm-proxy's HARNESS_BY_KEY_CATEGORY maps it to harness "slack"
 * (AIR-997), so slack-agent usage attributes like any tool's. Rows written
 * before that mapping keep their "api" stamp — detection inputs aren't
 * stored, so history is forward-only.
 */
export const SLACK_AGENT_KEY_CATEGORY = "slack-agent";

/**
 * RunPod credentials (AIR-1554): org-level keys minted from Compute › RunPod
 * and bound to a RunPod permission (client_runpod_key_binding). api-gateway
 * serves them on the RunPod passthrough only, swapped for the organization's
 * assigned RunPod Organization key; the web registry re-exports this so the
 * badge and the gateway can never disagree on the value.
 */
export const RUNPOD_KEY_CATEGORY = "runpod";

/**
 * AWS credentials (AIR-1558): org-level keys minted from Compute ›
 * Containers and used as the AWS access key id by an unmodified ECS SDK or
 * CLI repointed at api-gateway. The gateway signs every call with short-lived
 * credentials in the organization's own AWS member account; the category only
 * labels the key for what it is (any of the org's keys works on the surface).
 */
export const ECS_KEY_CATEGORY = "ecs";
